export default __webpack_public_path__ + "static/media/carousel-left.30634ca8.svg";